// @vue/component
export const BrRule = {
	name: 'BrRule',
	props: {
		// default property for every rule
		text: {
			type: String,
			default: '',
		},
	},
	template: `
		<br/>
	`,
};
